import { useWorkOrderChecklistFutureServiceList } from '@/core/domain/workorder/WorkOrdersChecklist/WorkOrdersChecklist.hooks';
import { message, Modal, ModalProps, Table } from 'antd';
import { useState } from 'react';
import { useWorkorderChecklistContext } from '../../WorkorderChecklistProvider';
import { WorkorderChecklistItemType } from '../../WorkorderChecklistProvider/WorkorderChecklistProvider.types';

interface Props extends Omit<ModalProps, 'onOk'> {
  onCancel: () => void;
  onOk: (ids: number[]) => void;
}

const FutureServiceToWorkorderModal: React.FC<Props> = ({ ...props }) => {
  const [itemIds, setItemIds] = useState<number[]>([]);
  const { checklistItemId, checklistItemType } = useWorkorderChecklistContext();

  const futureServiceList = useWorkOrderChecklistFutureServiceList({
    diagnosticId:
      checklistItemType == WorkorderChecklistItemType.Diagnostic
        ? checklistItemId
        : undefined,
    workOrderComplementId:
      checklistItemType == WorkorderChecklistItemType.Workorder
        ? checklistItemId
        : undefined,
  });

  function handleClose() {
    props.onCancel();
    setItemIds([]);
  }

  return (
    <Modal
      {...props}
      title="Enviar para OS"
      okText="Enviar"
      onCancel={handleClose}
      onOk={async () => {
        try {
          if (!itemIds.length) {
            return message.warning('Selecione pelo menos 1 serviço!');
          }
          props.onOk(itemIds);
        } catch {}
      }}
      destroyOnClose
    >
      <p>
        Selecione abaixo os serviços futuros que deseja enviar para o orçamento.
      </p>

      <p>
        <strong>Serviços</strong>
      </p>

      <Table
        dataSource={futureServiceList.data}
        columns={[{ dataIndex: 'description', title: 'Descrição' }]}
        rowSelection={{
          selectedRowKeys: itemIds,
          onChange: (keys) => setItemIds(keys as number[]),
        }}
        rowKey={(row) => row.id}
        pagination={false}
      />
    </Modal>
  );
};

export default FutureServiceToWorkorderModal;
